'use client';

import * as React from 'react';
import { Rows, GridFour } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { useCatalogViewStore, type CatalogViewMode } from '@/stores/catalog-view-store';

export function ViewToggle({ className }: { className?: string }) {
  const mobileViewMode = useCatalogViewStore((s) => s.mobileViewMode);
  const setMobileViewMode = useCatalogViewStore((s) => s.setMobileViewMode);

  const options: { value: CatalogViewMode; icon: React.ElementType; label: string }[] = [
    { value: 'horizontal', icon: Rows, label: 'Лента' },
    { value: 'grid', icon: GridFour, label: 'Сетка' },
  ];

  return (
    <div
      className={cn(
        'md:hidden inline-flex shrink-0 p-1 gap-0.5',
        'bg-[var(--surface-secondary)] dark:bg-white/5 rounded-pill',
        className
      )}
    >
      {options.map(({ value, icon: Icon, label }) => {
        const isActive = mobileViewMode === value;
        return (
          <button
            key={value}
            onClick={() => setMobileViewMode(value)}
            className={cn(
              'relative flex items-center gap-1.5 px-3 py-1.5',
              't-caption rounded-pill',
              'transition-colors duration-150',
              isActive
                ? 'text-white'
                : 'text-[var(--text-tertiary)] active:text-[var(--text-secondary)]'
            )}
            aria-label={label}
            aria-pressed={isActive}
          >
            {isActive && (
              <motion.div
                layoutId="view-toggle-bg"
                className={cn(
                  'absolute inset-0 rounded-pill',
                  'bg-[var(--primary)]',
                  // Одна роль вместо пары «светлая/тёмная»: shadow-glow сама
                  // читает var(--shadow-glow), а тема его переопределяет.
                  'shadow-glow'
                )}
                transition={{ type: 'spring', stiffness: 400, damping: 30 }}
              />
            )}
            <span className="relative z-10 flex items-center gap-1.5">
              <Icon className="h-4 w-4" weight={isActive ? 'fill' : 'regular'} />
              <span>{label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
